export const FETCH_DEVICES = 'mfa/fetchDevices';
export const MFA_SIGNIN = 'mfa/signin';
export const ADD_DEVICE = 'mfa/addDevice';
export const REMOVE_DEVICE = 'mfa/removeDevice';
export const VERIFY_OTP = 'mfa/verifyOtp';
export const CHECK_VERIFY_STATUS = 'mfa/checkVerifyStatus';
export const RESET_QUOTA = 'mfa/resetQuota';

export const ERROR_NO_EMAIL_FOUND = 'No email found';
export const ERROR_NO_AUTHORIZED_USER_FOUND = 'No authorized user found';
export const ERROR_VERIFYING_OTP = 'Error verifying OTP. Please try again.';

export const MFA_COMPLETED = 'COMPLETED';
export const MFA_INIT = 'INIT';
export const MFA_FAILED = 'FAILED';
export const MFA_OTP_REQUIRED = 'OTP_REQUIRED';
export const MFA_NO_USABLE_DEVICES = 'NO_USABLE_DEVICES';
export const NO_DEVICE_FOUND = "Couldn't find authenticating device for user";
export const LIMIT_EXCEEDED = 'Daily limit of SMS authentication attempts has been exceeded';
